import { render, staticRenderFns } from "./DeliveryDriverDetail.vue?vue&type=template&id=bcaeee34&lang=pug&"
import script from "./DeliveryDriverDetail.vue?vue&type=script&lang=js&"
export * from "./DeliveryDriverDetail.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryDriverDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports